namespace Matrix.Data {

    export interface DataExplorerGridOptions {
        identifier: string;
        title: string;
        propertyItems: Serenity.PropertyItem[];
        idProperty: string;
    }

    @Serenity.Decorators.registerClass()
    export class DataExplorerGrid extends SiteEntityGrid<any, DataExplorerGridOptions> {

        protected getDialogType() { return null; }
        protected getIdProperty() { return this.options.idProperty || "__id"; }
        protected getLocalTextPrefix() { return ""; }
        protected getService() { return DataExplorerService.baseUrl; }

        constructor(container: JQuery, options: DataExplorerGridOptions) {
            super(container, options);
        }

        protected getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        protected getPropertyItems() {
            return this.options.propertyItems || [];
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !Q.isEmptyOrNull(this.options.identifier) && !!this.options.propertyItems;
        }

        protected getInitialTitle() {
            return this.options.title || '';
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            (this.view.params as DataExplorerListRequest).Identifier = this.options.identifier;

            return true;
        }

        protected onViewProcessData(response) {
            response = super.onViewProcessData(response);
            
            if (this.getIdProperty() != "__id")
                return response;

            for (var i = 0; i < response.Entities.length; i++)
                response.Entities[i].__id = i + 1;

            return response;
        }
    }
}